import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    transform: translateX(500px);
    opacity: 0.5;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }

  to {
    opacity: 0;
    transform: translateX(500px);
  }
`;

const ToastContainer = styled.div`
  width: 200px;
  min-height: 75px;
  margin-top: 10px;
  background: ${props => props.theme.colors[props.type]};
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  animation: ${props => (props.isGoingToBeRemoved ? fadeOut : fadeIn)} 0.4s ease;
  position: relative;

  ${props =>
    props.theme.media.tablet &&
    `
		width: 100%;
	`}
`;

const ToastTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
`;

const ToastMessage = styled.p``;

const CloseIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;

  svg {
    font-size: 20px;
  }
`;

export { ToastContainer, ToastTitle, ToastMessage, CloseIcon };
